export const theme = {
  colors: {
    primary: "#09363F",
    primary2: "#00444e",
    secondary: "#DEF7F3",
    secondary2: "#578894",
    white: "#FFFFFF",
    gray1: "#656669",
    gray2: "#66686E",
    gray3: "#CCCCCC",
    gray4: "#849A9F",
    gray5: "#71888C",
    green: "#30CFB0",
  },
  borderRadius: {
    radius8: "8px",
  },
};
